import {
  UPLOAD_REQUEST,
  UPLOAD_SUCCESS,
  UPLOAD_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const ResumeUploadAction = (data, navigate, setUploadProgress) => {
  return async function (dispatch) {
    dispatch({ type: UPLOAD_REQUEST, payload: true });

    const OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/upload_resume`,
      method: "PUT",
      data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (setUploadProgress) {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        }
      },
    };

    return axios(OPTION)
      .then((res) => {
        dispatch(createDashboardBannerPre(res.data, navigate));

        // success toast message updated professionally
        toast.success("Resume uploaded successfully.");

        return res.data; // resolves promise so await works
      })
      .catch((error) => {
        dispatch({
          type: UPLOAD_FAIL,
          payload: false,
          error,
          msg: "Failed to upload resume",
        });

        toast.error(
          error?.response?.data?.status?.message ||
          "Failed to upload resume."
        );

        throw error; // reject promise → catch in component
      });
  };
};
export const createDashboardBannerPre = (data,navigate) => {
  return {
    type: UPLOAD_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};

export const ResumeDownloadAction = (id) => {

  return function (dispatch) {
    dispatch({
      type: UPLOAD_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/file/download?candidateID=${id}`,
      method: "GET",
     
      headers: {
        "content-type": "application/json",
        responseType: 'blob',
      },
    };

    return axios(OPTION)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
        dispatch(DownloadResumePre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: UPLOAD_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
        toast.error("Failed To download");
      });
  };
};
export const DownloadResumePre = (data) => {
  toast.success("Resume downloaded Successfully!");
  return {
    type: UPLOAD_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};